module.exports = __webpack_public_path__ + "img/tisco.965097dd.svg";